import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { FiX } from 'react-icons/fi';
import GuestAccountUpgrade from './GuestAccountUpgrade';
import { useConversionCopy } from './conversionCopy';
import { useGuestCopy } from './guestCopy';
import { rememberGuestSaveCTA, trackEvent } from './analytics';
import './guest.css';

export default function GuestAccountDialog({ redirectPath, filename, location = 'after_copy',
  purpose = 'save', fileRetained=false, onClose, onComplete }) {
  const copy = useConversionCopy();
  const guest = useGuestCopy();
  const dialog = useRef(null);
  const premium = purpose === 'premium';
  useEffect(() => {
    const element = dialog.current;
    const previousFocus = document.activeElement;
    element.showModal();
    element.querySelector('h2')?.focus({ preventScroll: true });
    trackEvent('guest_account_dialog_open', { cta_location: location, purpose, offer_variant: 'result_context_v4' });
    return () => {
      element.close();
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
      else document.querySelector('.transcript-copy-button')?.focus({ preventScroll: true });
    };
  }, [location, purpose]);
  return createPortal(<dialog ref={dialog} className="guest-account-dialog" aria-labelledby="guest-account-dialog-title"
    onKeyDown={event => { if (event.key === 'Escape') event.stopPropagation(); }}
    onCancel={event => { event.preventDefault(); onClose(); }}
    onClick={event => { if (event.target === event.currentTarget) onClose(); }}>
    <button type="button" className="guest-account-dialog__close" onClick={onClose} aria-label={copy.dialogClose}><FiX aria-hidden="true" /></button>
    <h2 id="guest-account-dialog-title" tabIndex={-1}>{premium ? copy.dialogPremiumTitle : copy.dialogTitle}</h2>
    {filename && <p className="guest-account-dialog__record">{filename}</p>}
    <p>{premium ? copy.dialogPremiumBody : copy.dialogBody}</p>
    {premium&&fileRetained&&<p>{copy.fileSavedLocally}</p>}
    <GuestAccountUpgrade embedded redirectPath={redirectPath} freeAccountOnly={!premium} onCancel={onClose} onComplete={onComplete}
      onMethod={method => {
        if (!premium) rememberGuestSaveCTA(method, location, 'result_context_v4');
        trackEvent('guest_upgrade_click', { method, cta_location: location, purpose, offer_variant: 'result_context_v4' });
      }} />
    {!premium && <small className="guest-account-dialog__storage">{guest.resultStorage}</small>}
  </dialog>, document.body);
}
